import { makeStyles } from '@material-ui/styles';

export const useStyles = makeStyles(() => ({
    wraper: {
        overflowX: 'hidden',
    },
}));
